import { useEffect, useState } from 'react';
import { useLanguage } from '@/common/hooks/useLanguageData';
import { resolveCurrentLanguage } from '../helpers/resolveCurrentLanguage';

export const useLanguageSwitcher = () => {
	const { lang, switchLanguage } = useLanguage();
	const [open, setOpen] = useState(false);
	const currentLanguage = resolveCurrentLanguage(lang);

	useEffect(() => {
		if (!open) {
			return undefined;
		}

		const handleKeyDown = (event) => {
			if (event.key === 'Escape') {
				setOpen(false);
			}
		};

		document.addEventListener('keydown', handleKeyDown);

		return () => document.removeEventListener('keydown', handleKeyDown);
	}, [open]);

	const handleSelect = (code) => {
		if (code !== lang) {
			switchLanguage(code);
		}

		setOpen(false);
	};

	return {
		lang,
		open,
		currentLanguage,
		handleToggle: () => setOpen((prev) => !prev),
		handleClose: () => setOpen(false),
		handleSelect,
	};
};
